import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  paperTitle: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  divider: {
    marginBottom: '1rem'
  },
}));

const ActionsCard = ({partner}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  // eslint-disable-next-line react/no-multi-comp
  const SimpleDialog = () => {
    return (
      <Dialog
        aria-labelledby="simple-dialog-title"
        onClose={handleClose}
        open={open}
      >
        <Grid
          alignItems="center"
          container
        >
          <Grid
            item
            sm={6}
            xs={12}
          >
            <Paper elevation={0}>
              <CardMedia
                alt={partner.alt}
                component="img"
                image={partner.img}
                object-fit
                title={partner.name}
              />
            </Paper>
          </Grid>
   
          <Grid
            item
            sm={6}
            xs={12}
          >
            <Paper
              className={classes.paper}
              elevation={0}
            >
              <Typography
                component="h3"
                style={{fontWeight: 'bold'}}
              >
                {partner.title}
              </Typography>
              <Divider className={classes.divider} />
              <Typography>
                {partner.desc}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Dialog>
    );
  }

  return (
    <>
      <SimpleDialog
        onClose={handleClose}
        open={open}
      />
      <Card
        elevation={0}
        onClick={handleClickOpen}
        square
      >
        <CardActionArea>
          <CardMedia
            alt={partner.alt}
            component="img"
            image={partner.img}
            object-fit
            title={partner.name}
          />
        </CardActionArea>
      </Card>
    </>
  );
}

ActionsCard.propTypes = {
  partner: PropTypes.object,
};

export default ActionsCard;
